import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input, Radio } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { SupportFormNestedFieldsContainer } from "./nestedFieldsContainer.js";
import { __, _i } from "../../utils/i18n.js";
const SupportFormWpHealthExportField = ()=>{
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, curValues)=>prevValues.questionType !== curValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            return !!getFieldValue("questionType") && getFieldValue("questionType") === ESupportTicketQuestionType.ProblemWithProduct && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "wpSiteHealth",
                        required: true,
                        label: __("Technical data about your WordPress installation"),
                        rules: [
                            {
                                required: true,
                                message: __("Please choose one option!")
                            }
                        ],
                        extra: _i(__("The health export will help us to better answer your question. {{a}}Learn where to get the health export in your WordPress!{{/a}}"), {
                            a: /*#__PURE__*/ _jsx("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: __("https://devowl.io/knowledge-base/wordpress-health-export/")
                            })
                        }),
                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                            children: [
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "export",
                                    children: __("Health Export (recommended)")
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "none",
                                    children: __("None")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, curValues)=>prevValues.wpSiteHealth !== curValues.wpSiteHealth,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return getFieldValue("wpSiteHealth") === "export" && /*#__PURE__*/ _jsx(SupportFormNestedFieldsContainer, {
                                children: /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "wpHealthExport",
                                    label: __("Site health export"),
                                    required: true,
                                    rules: [
                                        {
                                            required: true,
                                            message: __("Please insert your site health export!")
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Input.TextArea, {
                                        rows: 3
                                    })
                                })
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { SupportFormWpHealthExportField };
